import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { selectUser } from 'redux/user/selectors';
import { identifyUser } from 'utils/reporting';
import { initUserflow } from 'utils/userflow';
import { getLoginUrl } from 'service/cognitoService';
import { useRefreshToken } from 'hooks/useRefreshToken';
import { useNotificationService } from 'hooks/useNotificationService';
import { useExportNotificationsDeleteEvent } from 'hooks/useExportNotificationsDeleteEvent';
import { anonymousRoutes } from 'common/constants';
import { getAuthCookie } from 'utils/auth';
import { loadUserData } from 'redux/user';
import { usePolicyManagerCompleteEvent } from 'hooks/usePolicyManagerCompleteEvent';

export const App = ({ children }) => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);
  const [userLoaded, setUserLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      const auth = getAuthCookie();
      if (auth) {
        await dispatch(loadUserData());
      }
      setUserLoaded(true);
    })();
  }, [dispatch]);

  useRefreshToken();
  useNotificationService();
  useExportNotificationsDeleteEvent();
  usePolicyManagerCompleteEvent();

  useEffect(() => {
    if (user) {
      identifyUser(user);
      initUserflow(user);
    }
  }, [user]);

  useEffect(() => {
    if (!userLoaded || !router?.isReady) {
      return;
    }

    if (!user && !anonymousRoutes.includes(router.pathname) ) {
      window.location = getLoginUrl();
    } else {
      setIsLoading(false);
    }
  }, [user, userLoaded, router]);

  return isLoading ? null : children;
};
